import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        font-family: var(--sgdf-font-sans);
    }

    .sgdf-team-calendar {
        display: grid;
        grid-template-columns: 1fr / var(--meeting-length);
        grid-template-rows: 1fr/ 3;
    }

    .avatar-trombi {
        --size: 300px;
    }
    .small {
        font-size: 0.8em;
    }

    .horizontal-flex {
        display: flex;
        flex-direction: horizontal;
        align-items: center;
    }

    .sgdf-team-card-name {
        margin-left: 1em;
    }
    .sgdf-team-card {
        width: 100%;
        border: var(--team-color) 1px solid;
        border-radius: 0.5em;
    }

    .sgdf-team-card header {
        background-color: var(--team-color);
        border-radius: 0.5em 0.5em 0px 0px;
        padding: 0.6em 1em 0.5em 1em;
    }

    .sgdf-team-card header h3 {
        font-weight: bold;
        letter-spacing: 2px;
    }

    .sgdf-team-card-members {
        display: flex;
        flex-wrap: wrap;
        gap: 1em;
        border-radius: 0 0 0.5em 0.5em;
        background-color: white;
        padding: 1em;
    }
    .sgdf-team-card-member {
        width: 300px;
    }
    @media screen and (max-width: 1024px) {
        .sgdf-team-card-members {
            justify-content: space-around;
        }
    }

    @media screen and (max-width: 800px) {
        .sgdf-team-card-member {
            flex-grow: 1;
        }
    }

    .first-line {
        display: flex;
        justify-content: space-between;
    }
`;
//# sourceMappingURL=team-card.styles.js.map